export const expandMultiattack = (actions, multiattackAction) => {
  if (!Array.isArray(actions) || !Array.isArray(multiattackAction?.multiattack)) return [];
  const byId = new Map(actions.map((action) => [action?.action_id, action]));
  return multiattackAction.multiattack.flatMap((entry) => {
    const action = byId.get(entry?.action_id);
    const count = Number(entry?.count);
    if (!action || action === multiattackAction || action.name?.trim().toLowerCase() === 'multiattack' || !Number.isInteger(count) || count <= 0) return [];
    return Array.from({ length: count }, (_, index) => ({ action, number: index + 1, count }));
  });
};

export const hasStructuredMultiattack = (action) =>
  action?.name?.trim().toLowerCase() === 'multiattack' && Array.isArray(action.multiattack) && action.multiattack.length > 0;
